import { COLLECTION_GAPS } from 'vars/collection-sizes'
import { GRID } from 'vars/grid-layout'

export const GridRowGaps = {
  DEFAULT: COLLECTION_GAPS.GRID_GAP_HORIZONTAL,
  DETAILS_RECOMMENDATIONS: GRID.GapDetailsRecommendations,
}
export const GridColumnGaps = {
  DEFAULT: COLLECTION_GAPS.GRID_GAP_VERTICAL,
  DETAILS_RECOMMENDATIONS: GRID.GapDetailsRecommendations,
}
